import React, { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import { Link, useNavigate } from "react-router-dom";
import profile from "../../../src/assets/images/demo.jpg";
import { useSelector } from "react-redux";
import { PopUp } from "../../utils/utilities";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { useDispatch } from "react-redux";
import { setPageData } from "../../redux/Slices/Pages";
import Logo from '../../assets/images/logo.svg'
//const LOGO_PATH = `${process.env.PUBLIC_URL || ""}/images/logo.svg`;

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logout, showLogout] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [logoutModal, setLogoutModal] = useState({ value: false });
  const [adminList, setAdminList] = useState();

  const loginSuccess = useSelector((state) => state.loginInfo.userInformation.data);

  const logOutClickHandler = (event) => {
    event.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    // if (localStorage.getItem("sessionToken")) {
    //  return;
    // } else {
    //   PopUp("Session Expired.");
    //   navigate("/");
    // }
  }, []);

  const logOut = () => {
    // Clear local storage
    localStorage.clear();

    // Optionally, clear session storage as well
    sessionStorage.clear();

    // Navigate to the login or home page
    navigate("/");

    // Optional: Refresh the page to ensure everything resets
    window.location.reload();
  };

  return (
    <>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo">
            <img src={Logo} alt="logo" style={{ maxHeight: "48px", width: "auto", objectFit: "contain" }} />
          </a>
          <a className="navbar-brand brand-logo-mini">
            <img src={Logo} alt="logo" style={{ maxHeight: "48px", width: "auto", objectFit: "contain" }} />
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center">
          <ul className="navbar-nav navbar-nav-right">
            <li className={`nav-item nav-profile dropdown drop-right bg-black w-auto ${logout ? " show" : ""}`} style={{ cursor: "pointer" }} onClick={logOutClickHandler}>
              <a className="nav-link align-items-center" onClick={() => showLogout(!logout)}>
                {/* <div className="nav-profile-img">
                  <img src={profile} alt="image" />
                </div> */}
                <div className="nav-profile-text">
                  <p className="mb-0">{loginSuccess?.user?.role || "Admin"}</p>
                </div>
              </a>
              {logout && (
                <div className={`dropdown-menu right-menu border-black py-0 ${logout ? " show" : ""}`}>
                  <a class="dropdown-item px-3 bg-black" onClick={() => setLogoutModal({ value: true })}>
                    <i class="mdi mdi-logout mr-2"></i> Logout
                  </a>
                </div>
              )}
            </li>
          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span className="mdi mdi-menu color-lightblue" />
          </button>
        </div>
        <Modal show={logoutModal.value} onClose={() => setLogoutModal({ value: false })} style={{ zIndex: "1000" }} className=" shadow-none">
          <div className="modal-dialog modal-sm modal-center" role="document">
            <div className="modal-content bgPrimary">
              <div className="modal-body text-center my-4 py-4">
                <h4 className="text-white">
                  Do you want to
                  <br />
                  Logout?
                </h4>
                <div className="col-sm-12 mx-auto d-flex align-items-center mt-4 row">
                  <div className="col-6 px-2">
                    <a type="button" className="btn btn-primary	btn-lg btn-block font-16 rounded-lg" onClick={logOut}>
                      Yes
                    </a>
                  </div>
                  <div className="col-6 px-2">
                    <button type="button" className="btn btn-default btn-lg btn-block font-16 rounded-lg" data-dismiss="modal" onClick={() => setLogoutModal({ value: false })}>
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </nav>
    </>
  );
};

export default Header;
